import React from 'react';
import { motion } from 'framer-motion';
import { SlideLayout } from '../SlideLayout';
import { BookOpen } from 'lucide-react';
const sources = [{
  id: 24,
  text: 'FPGA vs GPU vs CPU vs MCU — Hardware Options for AI',
  pub: 'Avnet Silica',
  url: 'https://my.avnet.com/silica/resources/article/fpga-vs-gpu-vs-cpu-hardware-options-for-ai-applications/'
}, {
  id: 25,
  text: 'FPGA vs GPU: Choosing for Trading Systems',
  pub: 'LinkedIn',
  url: 'https://www.linkedin.com/posts/omid-nasrollahi-31baa5223_hft-fpga-gpu-activity-7337168219536850944-r86E'
}, {
  id: 26,
  text: 'Pushing up to the Limit of Memory Bandwidth for LLM Inference',
  pub: 'arXiv',
  url: 'https://arxiv.org/html/2502.10659v1'
}, {
  id: 27,
  text: 'Dataflow & Tiling Strategies in Edge-AI FPGA Accelerators',
  pub: 'arXiv',
  url: 'https://arxiv.org/html/2505.08992v2'
}, {
  id: 28,
  text: 'TerEffic: Highly Efficient Ternary LLM Inference on FPGA',
  pub: 'arXiv',
  url: 'https://arxiv.org/html/2502.16473v1'
}, {
  id: 29,
  text: 'FPGA Accelerated Sparse Attention for Long Context LLM Prefill',
  pub: 'arXiv',
  url: 'https://arxiv.org/html/2602.20515v1'
}, {
  id: 30,
  text: 'GPU-FPGA LLM Inference via Collaborative Heterogeneous Architecture',
  pub: 'Tsinghua University',
  url: 'https://nicsefc.ee.tsinghua.edu.cn/nics_file/pdf/f05fe322-6f06-47e9-b3c2-18aaa8cec4ae.pdf'
}, {
  id: 31,
  text: 'CPU vs GPU vs FPGA: Best Compute Choice for AI Workloads',
  pub: 'iLink Digital',
  url: 'https://www.ilink-digital.com/insights/blog/cpu-vs-gpu-vs-fpga-ai-workloads/'
}, {
  id: 32,
  text: 'Wild claims about Relevance of FPGAs in the Future of AI',
  pub: 'Reddit r/FPGA',
  url: 'https://www.reddit.com/r/FPGA/comments/1htxgf6/is_this_true_wild_claims_about_relevance_of_fpgas/'
}, {
  id: 33,
  text: 'LLM Inference Hardware: An Enterprise Guide to Key Players',
  pub: 'Intuition Labs',
  url: 'https://intuitionlabs.ai/articles/llm-inference-hardware-enterprise-guide'
}, {
  id: 34,
  text: 'Edge AI Showdown: FPGA vs GPU',
  pub: 'LinkedIn (Dr. Carlos Ruiz Viquez)',
  url: 'https://www.linkedin.com/posts/carlosruizviquez_title-edge-ai-showdown-fpga-vs-gpu-a-activity-7399896363041443840--WDZ'
}, {
  id: 35,
  text: 'LLMCompass: Enabling Efficient Hardware Design for LLMs',
  pub: 'ISCA 2024',
  url: 'https://augustning.com/assets/papers/llmcompass-isca-2024.pdf'
}, {
  id: 36,
  text: 'In the LLM era, will FPGA be better than GPU in running AI?',
  pub: 'EEWorld',
  url: 'https://en.eeworld.com.cn/mp/EEWorld/a378673.jspx'
}, {
  id: 37,
  text: 'LUT-LLM: Efficient LLM Inference with Memory-Optimized Lookup Tables',
  pub: 'arXiv',
  url: 'https://arxiv.org/abs/2511.06174'
}, {
  id: 38,
  text: 'FPGAs for Highest Performance Inference',
  pub: 'Linaro Connect BKK19',
  url: 'https://static.sched.com/hosted_files/bkk19/e9/BKK19-321_FPGAs%20for_Highest_Performance_Inference.pdf'
}, {
  id: 39,
  text: 'Why can FPGAs be more power efficient than ASIC CPUs/GPUs?',
  pub: 'Reddit r/FPGA',
  url: 'https://www.reddit.com/r/FPGA/comments/5bbxd0/why_can_fpgas_be_more_power_efficient_than_asic/'
}, {
  id: 40,
  text: 'Prefill-Oriented Inference Architecture',
  pub: 'Emergent Mind',
  url: 'https://www.emergentmind.com/topics/prefill-oriented-inference-architecture'
}, {
  id: 41,
  text: 'I made an LLM run on bare-metal (no OS)',
  pub: 'Reddit',
  url: 'https://www.reddit.com/r/FunMachineLearning/comments/1pmf231/p_i_made_an_llm_run_on_baremetal_no_os_boots_from/'
}, {
  id: 42,
  text: 'How to Achieve Ultra-Low Latency LLM Inference in the Cloud',
  pub: 'GMI Cloud',
  url: 'https://www.gmicloud.ai/blog/how-to-achieve-ultra-low-latency-llm-inference-in-the-cloud-2026-engineering-guide'
}, {
  id: 43,
  text: 'Prefill and Decode for Concurrent Requests',
  pub: 'Hugging Face Blog',
  url: 'https://huggingface.co/blog/tngtech/llm-performance-prefill-decode-concurrent-requests'
}, {
  id: 44,
  text: 'Prefill Optimization',
  pub: 'Aussie AI',
  url: 'https://www.aussieai.com/research/prefill'
}, {
  id: 45,
  text: 'OS-Level Challenges in LLM Inference and Optimizations',
  pub: 'Eunomia',
  url: 'https://eunomia.dev/blog/2025/02/18/os-level-challenges-in-llm-inference-and-optimizations/'
}, {
  id: 46,
  text: 'AI Hardware: Are GPUs Losing Their Long‑Term Value?',
  pub: 'LinkedIn',
  url: 'https://www.linkedin.com/pulse/ai-hardware-gpus-losing-longterm-value-mahmoud-abufadda-6immf'
}, {
  id: 47,
  text: "AI Inference Costs Dropped Up to 10x on Nvidia's Blackwell",
  pub: 'VentureBeat',
  url: 'https://venturebeat.com/infrastructure/ai-inference-costs-dropped-up-to-10x-on-nvidias-blackwell-but-hardware-is'
}];
export function SourcesPage2Slide() {
  const half = Math.ceil(sources.length / 2);
  const col1 = sources.slice(0, half);
  const col2 = sources.slice(half);
  return <SlideLayout slideNumber={20} totalSlides={20} title="References (2/2)" data-id="element-472">
      <div className="max-w-7xl mx-auto w-full" data-id="element-473">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="flex items-center justify-center gap-3 mb-6" data-id="element-474">
          <BookOpen size={24} className="text-brand-primary" data-id="element-475" />
          <h2 className="text-3xl font-bold" data-id="element-476">Sources & References (cont.)</h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="grid grid-cols-1 md:grid-cols-2 gap-x-8" data-id="element-477">
          {[col1, col2].map((col, colIdx) => <div key={colIdx} className="space-y-1" data-id="element-478">
              {col.map(source => <a key={source.id} href={source.url} target="_blank" rel="noopener noreferrer" className="flex gap-3 py-2 border-b border-brand-border/20 last:border-0 hover:bg-brand-primary/5 rounded px-2 -mx-2 transition-colors cursor-pointer group" data-id="element-479">
                  <span className="font-mono font-bold text-brand-primary shrink-0 pt-0.5" data-id="element-480">
                    [{source.id}]
                  </span>
                  <span className="text-white group-hover:text-brand-primary transition-colors" data-id="element-481">
                    {source.text}{' '}
                    <span className="text-brand-muted" data-id="element-482">— {source.pub}</span>
                  </span>
                </a>)}
            </div>)}
        </motion.div>
      </div>
    </SlideLayout>;
}